import { useCallback, useEffect, useRef } from 'react';
export default function useReadingAudioFollow(state) {
  const ref = useRef(null);
  const unit = state?.units?.[state.index];
  const position = unit ? `${unit.segmentIndex}:${unit.sentenceIndex}` : '';
  const activeId = state?.activeId;
  const status = state?.status;
  const follow = useCallback(() => {
    const root = ref.current;
    const target = root?.querySelector(`[data-reading-position="${position}"]`);
    if (!target) return;
    const box = root.getBoundingClientRect(); const item = target.getBoundingClientRect();
    if (item.top < box.top || item.bottom > box.bottom) root.scrollTo?.({ top: root.scrollTop + item.top - box.top - box.height * .25, behavior: 'smooth' });
  }, [position]);
  // Scrolling by hand never disables following the next spoken sentence.
  // Only move the reading viewport, and keep the position while paused.
  useEffect(() => { if (activeId && status === 'playing') follow(); }, [activeId, status, follow]);
  return { ref,
    classFor: item => `${item?.segmentIndex}:${item?.sentenceIndex || 0}` !== position ? ''
      : activeId ? 'reading-audio-highlight' : status === 'loading' ? 'reading-audio-loading' : '' };
}
